module.exports = __webpack_public_path__ + "img/architecture_technique.61b3d99f.png";